import { Reveal } from "./Reveal";
import { Quote, Tractor, Truck, Building2, Mountain } from "lucide-react";

const BG =
  "https://static.prod-images.emergentagent.com/jobs/ea29b796-903f-4580-bdca-2f501b22a9b8/images/1cd348c305c0a16366e845d84ba9724b66feabeb0db747ad3255081245d2a701.png";

const clients = [
  {
    icon: Tractor,
    name: "AgroIndustrias del Norte",
    sector: "Sector Agropecuario",
    quote:
      "Gracias a los fondos de desarrollo y la financiera rural de Lex Balance Perfecto, pudimos mecanizar nuestra producción justo a tiempo para la temporada de cosecha.",
  },
  {
    icon: Truck,
    name: "Logística Global S.A.",
    sector: "Transporte y Logística",
    quote:
      "Su servicio de factoraje y dispersión de dinero transformó nuestro flujo de efectivo; la nómina de nuestros choferes ahora se dispersa de manera impecable y segura.",
  },
  {
    icon: Building2,
    name: "Inmobiliaria del Centro",
    sector: "Bienes Raíces",
    quote:
      "Establecer nuestro fideicomiso financiero y utilizar su operadora de sociedades de inversión nos dio la certeza jurídica y el rendimiento que nuestros inversionistas exigían.",
  },
  {
    icon: Mountain,
    name: "Financiera Comunitaria Sierra Azul",
    sector: "SOFIPO Comunitaria",
    quote:
      "Como organismo de integración, valoramos el soporte técnico de Lex Balance Perfecto; sus valuadoras y asesores nos permitieron regularizar nuestra SOFIPO eficientemente.",
  },
];

export const Diferenciadores = () => {
  return (
    <section
      id="diferenciadores"
      data-testid="diferenciadores-section"
      className="relative bg-[#102615] text-white py-24 md:py-36 overflow-hidden grain"
    >
      <div className="absolute -right-32 top-1/2 -translate-y-1/2 w-[700px] h-[700px] hidden lg:block opacity-[0.06] pointer-events-none">
        <img src={BG} alt="" className="w-full h-full object-contain" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 text-[#C1C82A] mb-6">
                <span className="h-px w-10 bg-[#C1C82A]" />
                <span className="overline">Clientes</span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl leading-[1.04] text-white">
                Nuestros <em className="text-[#C1C82A]">clientes</em>.
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5">
            <Reveal delay={0.1}>
              <p className="text-base md:text-lg text-white/65 leading-relaxed md:text-right">
                Empresas y organismos que confían en Lex Balance Perfecto para
                impulsar su crecimiento financiero, jurídico y operativo.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {clients.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.name} delay={i * 0.07}>
                <article
                  data-testid={`client-card-${i}`}
                  className="relative h-full bg-white/[0.03] border border-white/10 p-8 md:p-10 backdrop-blur-sm hover:bg-white/[0.06] hover:border-[#C1C82A]/40 transition-all duration-500 flex flex-col"
                >
                  <Quote
                    size={36}
                    strokeWidth={1}
                    className="absolute top-7 right-8 text-[#C1C82A]/25"
                  />

                  <p className="font-display text-lg md:text-2xl text-white leading-snug italic mb-10 pr-10">
                    “{c.quote}”
                  </p>

                  <div className="mt-auto pt-6 border-t border-white/10 flex items-center gap-4">
                    <div className="w-12 h-12 border border-[#C1C82A]/40 flex items-center justify-center text-[#C1C82A] shrink-0">
                      <Icon size={20} strokeWidth={1.6} />
                    </div>
                    <div>
                      <div className="font-display text-lg text-white leading-tight">
                        {c.name}
                      </div>
                      <div className="text-[10px] tracking-[0.28em] uppercase text-white/50 mt-1">
                        {c.sector}
                      </div>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Diferenciadores;
